// Opening cash float (INITIAL) / WITHDRAW registration with the Tax Administration → FCDC.
import React, { useEffect, useState } from 'react';
import { Banknote, CheckCircle2, Loader2, AlertTriangle } from 'lucide-react';
import { apiCall } from './_shared';

const eur = (v) => `€${Number(v || 0).toFixed(2)}`;

const CashDepositCard = ({ onChanged }) => {
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState('');
  const [op, setOp] = useState('initial');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const load = async () => { try { setData(await apiCall('/api/admin/fiscal/cash-deposit?days=7')); } catch (e) { setErr(e.message); } };
  useEffect(() => { load(); }, []);

  const submit = async () => {
    const a = Number(amount);
    if (!(a > 0)) { setErr('Enter an amount greater than 0'); return; }
    if (!window.confirm(`Register ${op === 'initial' ? 'opening cash float' : 'cash withdrawal'} of ${eur(a)} with the Tax Administration?`)) return;
    setBusy(true); setErr('');
    try {
      await apiCall('/api/admin/fiscal/cash-deposit', { method: 'POST', body: JSON.stringify({ amount: a, operation: op }) });
      setAmount(''); await load(); onChanged && onChanged();
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  const history = (data?.history || []).slice(0, 8).map((d) => (
    <div key={d.id} className="flex items-center justify-between text-xs py-1 border-b last:border-0" data-testid={`cash-deposit-row-${d.id}`}>
      <span className="text-slate-500">{d.date} · {d.operation.toUpperCase()}</span>
      <span className="font-semibold">{eur(d.amount)}</span>
      {d.status === 'ok' ? <span className="text-emerald-700 font-mono" title={d.fcdc}>FCDC {String(d.fcdc).slice(0, 8)}…</span>
        : <span className="text-red-600" title={d.error}>failed</span>}
    </div>
  ));

  return (
    <div className="bg-white rounded-xl border p-4 space-y-3" data-testid="cash-deposit-card">
      <h3 className="font-bold text-slate-900 flex items-center gap-2"><Banknote className="w-4 h-4 text-emerald-600" /> Cash deposit · Početno stanje blagajne</h3>
      {data?.today_initial ? (
        <div className="text-xs bg-emerald-50 border border-emerald-200 rounded-lg p-2 text-emerald-800 flex items-center gap-1" data-testid="cash-deposit-today-ok">
          <CheckCircle2 className="w-3.5 h-3.5" /> Opening float registered today: <b>{eur(data.today_initial.amount)}</b> · FCDC <span className="font-mono">{String(data.today_initial.fcdc).slice(0, 8)}…</span>
        </div>
      ) : (
        <div className="text-xs bg-amber-50 border border-amber-200 rounded-lg p-2 text-amber-800 flex items-center gap-1" data-testid="cash-deposit-today-missing">
          <AlertTriangle className="w-3.5 h-3.5" /> No opening cash deposit registered for {data?.today || 'today'} yet — register it before the first cash invoice.
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        <select value={op} onChange={(e) => setOp(e.target.value)} className="border rounded-lg px-2 py-1.5 text-sm" data-testid="cash-deposit-op">
          <option value="initial">Opening float (INITIAL)</option><option value="withdraw">Withdraw (WITHDRAW)</option>
        </select>
        <input type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Amount €" className="border rounded-lg px-2 py-1.5 text-sm w-32" data-testid="cash-deposit-amount" />
        <button type="button" onClick={submit} disabled={busy || !data?.ready} className="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-1" data-testid="cash-deposit-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Banknote className="w-4 h-4" />} Register
        </button>
        {data && !data.ready && <span className="text-xs text-amber-700">Fiscal settings incomplete — configure codes & certificate first.</span>}
      </div>
      {err && <div className="text-xs text-red-600" data-testid="cash-deposit-error">{err}</div>}
      {history.length > 0 && <div data-testid="cash-deposit-history">{history}</div>}
    </div>
  );
};

export default CashDepositCard;
